﻿import {PlayerPrefs} from "../../Utils/Unity/PlayerPrefs";
import {GameManager} from "../../Game/GameManager";
import {Core} from "../../Base/Core";
import {Random} from "../../Utils/Unity/Random";
import {UISprite} from "./Base/UISprite";
import {UIButton} from "./Base/UIButton";
import {gsap} from "gsap";

const PREFS_NEXT_CHEST = "cr2tbct34bc72tbx32dx56v3r";
const PREFS_SKIPS_COUNTER = "wuyfn283rtycn83etfc3rt4c";

// See assets
const WING_ANCHOR = [
    0.8990384615384616,
    0.8865248226950354,
    0.20253164556962025,
    0.1005586592178771,
];

const CHEST_ANIMATION_STEP = 0.2;
const CHEST_ANIMATION_TIME = CHEST_ANIMATION_STEP * WING_ANCHOR.length;

class ChestWing extends UISprite {

    get value() {
        return this.items.find(item => item.Active);
    }

    set value(val) {
        val = ~~val % this.items.length;
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].SetActive(i === val);
        }
    }

    Awake() {
        this.items = WING_ANCHOR.map((anchor, idx) => {
            let item = this.addChild(new UISprite(`chest/${idx}`));
            item.anchor.set(1, anchor);
            item.SetActive(idx === 0);
            return item;
        });

        this._animation = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
            yoyo: true,
        });
        for (let i = 0; i < this.items.length; i++) {
            this._animation.add(() => this.value = i, CHEST_ANIMATION_STEP * i);
        }
    }
}

export class ChestButton extends UISprite {

    get nextChestTime() {
        return PlayerPrefs.GetInt(PREFS_NEXT_CHEST, 0);
    }

    set nextChestTime(value) {
        PlayerPrefs.SetInt(PREFS_NEXT_CHEST, value);
    }

    get isChestReady() {
        if (Core.Player.PlanetsSave.collection.length < 7) return false;
        return (Date.now() - this.timeOfEpochSelection) >= 5 && this.nextChestTime <= Date.now();
    }

    get skipsCounter() {
        return PlayerPrefs.GetInt(PREFS_SKIPS_COUNTER, 0);
    }

    set skipsCounter(value) {
        PlayerPrefs.SetInt(PREFS_SKIPS_COUNTER, value);
    }

    Awake() {
        super.Awake();
        this.onEpochSelected = this.onEpochSelected.bind(this);
        this.onPlayerChanged = this.onPlayerChanged.bind(this);

        this.leftWing = this.addChild(new ChestWing());
        this.rightWing = this.addChild(new ChestWing());
        this.rightWing.scale.x = -1;

        this.body = this.addChild(new UIButton("chest/body"));

        this.leftWing.position.set(-this.body.texture.width * 0.5, 0);
        this.rightWing.position.set(this.body.texture.width * 0.5, 0);

        this._goAnimation = null;
        this.movementRect = new PIXI.Rectangle();

        this.timeOfEpochSelection = Date.now();
        this.checkIndex = 0;

        this.body.on("pointertap", () => {
            this.SetActive(false);
            Core.UI.chestOpen.Show();
            this.ShowAfterNMinutes(60);
        });

        GameManager.on("EpochSelected", this.onEpochSelected);
        Core.Player.on("Changed", this.onPlayerChanged);

        this.body._animation = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
            yoyo: true,
        }).to(this.body, {
            pixi: {scaleY: 0.8},
            duration: CHEST_ANIMATION_TIME * (6 / 8)
        });

        this.SetActive(false);
        this.fitLayout();
    }

    fitLayout(viewport = Core.app.viewport) {
        this.scale.set(viewport.width * 0.2 / this.body.texture.width);
        this.movementRect.copyFrom(
            viewport.clone().pad(viewport.width * 0.5, -viewport.height * 0.3)
        );
        this.position.set(200, 400);
    }

    SetActive(val) {
        super.SetActive(val);
        if (this.Active) {
            this.body._animation.resume();
            this.leftWing._animation.resume();
            this.rightWing._animation.resume();
        } else {
            this.body._animation.pause();
            this.leftWing._animation.pause();
            this.rightWing._animation.pause();
            this._killGoAnimation();
        }
    }

    onEpochSelected(epochId) {
        this.timeOfEpochSelection = Date.now();
        if (this.Active) {
            this.skipsCounter++;
            this.SetActive(false);
            if (this.skipsCounter >= 3) {
                this.ShowAfterNMinutes(60);
            } else {
                this.ShowAfterNMinutes(5);
            }
        }
    }

    onPlayerChanged() {
        if (!this.Active) {
            this.checkIndex++;
            if (this.checkIndex <= 10 || !this.isChestReady) return;
            if (Core.Player.PlanetsSave.collection.length < Core.GameData.Config.chestCreatureId) return;
            this.checkIndex = 0;
            this.Go();
        }
    }

    _killGoAnimation() {
        if (this._goAnimation) this._goAnimation.kill();
        this._goAnimation = null;
    }

    Go() {
        this._killGoAnimation();
        let {left, right, top, bottom} = this.movementRect;
        this.position.set(left, Random.Range(top, bottom));
        this._goAnimation = gsap.timeline()
            .to(this,{x: right, duration: 60})
            .eventCallback("onComplete", () => {
                if (this.skipsCounter >= 3) {
                    this.ShowAfterNMinutes(60);
                } else {
                    this.ShowAfterNMinutes(5);
                }
                this.SetActive(false);
            })
        ;
        this.SetActive(true);
    }

    ShowAfterNMinutes(minutes) {
        this.nextChestTime = Date.now() + (minutes * 60 * 1000);
    }
}
